<!--<div-->
<!--  class="flex-row flex-align-center flex-justify-between"-->
<!--  style="margin-bottom: 1rem;border-bottom: 1px solid #c5d0dc">-->
<!--  <div>-->
<!--    <strong>{{ field.field_type }}</strong>-->
<!--  </div>-->
<!--  <div>-->
<!--    <p-button-->
<!--      icon="fa fa-trash"-->
<!--      size="small"-->
<!--      variant="text"-->
<!--      [label]="Yii.t('app', 'Delete')"-->
<!--      (click)="fsvc.DeleteField(field.field_id)"-->
<!--    />-->
<!--    &lt;!&ndash;Duplicate Field &ndash;&gt;-->
<!--    &nbsp;-->
<!--    <p-button-->
<!--      icon="fa fa-copy"-->
<!--      variant="text"-->
<!--      severity="warn"-->
<!--      [label]="Yii.t('app', 'Duplicate')"-->
<!--      (click)="fsvc.DuplicateField(field)">-->
<!--    </p-button>-->
<!--  </div>-->
<!--</div>-->

@if (field.field_type != 'richText') {
  <!-- Field Title -->
  <div class="form-row flex-align-center">
    <label>{{ Yii.t('app', 'Field Title') }}</label>
    <div>
      <input
        pInputText
        style="width: 100%;max-width: 480px"
        placeholder="{{(field.field_title)? field.field_title : 'Field-'+( field.field_id +1)}}"
        [(ngModel)]="field.field_title"
        (change)="change()"
      />
    </div>
  </div>
  <!-- / Field Title -->
}

<!-- Field hint -->
<div class="form-row flex-align-center">
  <label>{{ Yii.t('app', 'Field Hint') }}</label>
  <div>
    <input
      pInputText
      style="width: 100%;max-width: 480px"
      [(ngModel)]="field.field_hint"
      (change)="change()"
    />
  </div>
</div>
<!-- / Field hint-->

@if (field.field_type != 'note'
&& field.field_type != 'richText'
&& field.field_type != 'calculated_field'
&& field.field_type != 'duplicate_block'
&& !(field.field_type == 'signature' && field.required_employee_signature)) {
  <!-- Required -->
  <div class="form-row">
    <label></label>
    <div class="flex-row gap-8px flex-align-center">
      <p-checkbox
        binary="true"
        [(ngModel)]="field.field_required"
        (onChange)="change()"
      />
      <span>{{ Yii.t('app', 'Required') }}</span>
    </div>
  </div>
  <!-- / Required -->
}

<!-- Disabled -->
@if ((!field.field_required)
&& (field.field_type != 'note')
&& (field.field_type != 'scale')
&& (field.field_type != 'richText')
&& (field.field_type != 'signature')
&& (field.field_type != 'calculated_field')
&& (field.field_type != 'duplicate_block')) {
  <div class="form-row">
    <label></label>
    <div class="flex-row gap-8px flex-align-center">
      <p-checkbox
        binary="true"
        [(ngModel)]="field.field_disabled"
        (onChange)="change()"
      />
      <span>{{ Yii.t('be_forms', 'Disabled') }}</span>
    </div>
  </div>
}
